export default "__VITE_ASSET__Bus7oVJC__"